import { StyleObj } from '../../@types';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

const DEFAULT_STYLES: StyleObj = {
  root: {
    backgroundColor: 'neutral.100',
    py: 0.5,
    px: 1.5,
    minHeight: 40,
    mt: 1.5,
    mb: 0,
    mx: 1.5,
    borderRadius: 2,
  },
  icon: {
    color: 'error.main',
    fontSize: 20,
  },
  message: {
    color: 'neutral.600',
  },
};

const NEOBET_STYLES: StyleObj = {
  ...DEFAULT_STYLES,
  root: {
    ...DEFAULT_STYLES.root,
    backgroundColor: 'neutral.600',
    border: '1px solid',
    borderColor: 'error.300',
    px: 2,
    py: 0,
    mt: 0,
    mx: 0,
  },
  icon: {
    color: 'error.400',
    fontSize: 16,
  },
  message: {
    typography: 'body3',
    fontWeight: 500,
    color: 'neutral.100',
  },
};

export const BETSLIP_ERROR_MESSAGE_SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: DEFAULT_STYLES,
  [SKIN.GOLA]: DEFAULT_STYLES,
  [SKIN.NEOBET]: NEOBET_STYLES,
};
